export const STATUS_GROUP_PENDING = 'Pending';
export const STATUS_GROUP_UNSOLD = 'Unsold';
export const STATUS_GROUP_SOLD = 'Sold';
export const STATUS_GROUP_WITHDRAWN = 'Withdrawn';

const stringIdByLabel = {
    [STATUS_GROUP_PENDING]: 'pending',
    [STATUS_GROUP_UNSOLD]: 'unsold',
    [STATUS_GROUP_SOLD]: 'sold',
    [STATUS_GROUP_WITHDRAWN]: 'withdrawn'
};

export default class Lot {
    static getStatusStringId(statusLabel) {
        let result = null;
        if (statusLabel !== null && stringIdByLabel[statusLabel]) {
            result = stringIdByLabel[statusLabel];
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./app/general/js/lot.js